module.exports = __webpack_public_path__ + "img/yegr-mob.5616366b.png";